import React from "react";
import { TableRow } from "@mui/material";
import { BoldMenuText } from "components/common/text/text.component";
import { PageSection } from "components/common/Wrapper";
import CustomTable from "components/table/table.component";
import { TableBodyCell } from "components/table/table.style";
import { SoftwareVersionTypes } from "../versions.api";
import { SOFTWARE_VERSIONS_GRID_COLUMNS, SoftwareVersionColumnTypes } from "../versions.config";

interface VersionTableTypes {
  title: string;
  handleRequestSort: (order: string, orderBy: string) => void;
  data: SoftwareVersionTypes[];
  dataList: SoftwareVersionTypes[];
}

export default function VersionTable({ title, handleRequestSort, data, dataList }: VersionTableTypes): JSX.Element {
  return (
    <div>
      <BoldMenuText style={{ paddingBottom: "8px" }}>{title}</BoldMenuText>
      <PageSection>
        <CustomTable>
          <CustomTable.Header onRequestSort={handleRequestSort} columns={SOFTWARE_VERSIONS_GRID_COLUMNS} />

          <CustomTable.Body isLoading={false} deviceData={data}>
            {dataList.map((row: SoftwareVersionTypes, i: number) => {
              return (
                <TableRow>
                  {SOFTWARE_VERSIONS_GRID_COLUMNS.map((column: SoftwareVersionColumnTypes) => {
                    const value = row[column.id as keyof SoftwareVersionTypes];
                    return <TableBodyCell style={{ textAlign: column.align }}>{value}</TableBodyCell>;
                  })}
                </TableRow>
              );
            })}
          </CustomTable.Body>
        </CustomTable>
      </PageSection>
    </div>
  );
}
